import { FileUploadRoundedIcon } from 'components/icons'
import { Card, SizableText, useTheme, View } from 'tamagui'
import { useEffect, useMemo } from 'react'
import { DropzoneOptions, useDropzone } from 'react-dropzone'

interface Props {
    options?: DropzoneOptions
    onUpload?: (files: File[]) => void
    children?: React.ReactNode
}

export default function DropZoneInner({ options, onUpload, ...props }: Props) {
    const theme = useTheme()
    const { acceptedFiles, getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
        useDropzone(options)

    useEffect(() => {
        if (onUpload) {
            onUpload(acceptedFiles as any)
        }
    }, [acceptedFiles])

    const borderColor = useMemo(() => {
        if (isDragAccept) return '$primary'
        if (isDragReject) return '$red10'
        return '$borderColor'
    }, [isFocused, isDragAccept, isDragReject])

    return (
        <View {...getRootProps({ className: 'dropzone' })}>
            <Card
                padded
                backgroundColor="$gray3"
                borderWidth={2}
                borderColor={borderColor}
                borderStyle="dashed"
                borderRadius="$3"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
                gap="$2"
                paddingHorizontal="$4"
                flexGrow={1}
                marginTop="$2"
                cursor="pointer"
                animation="quick"
            >
                <input {...getInputProps()} />
                <View
                    width={32}
                    height={32}
                    borderRadius={16}
                    backgroundColor="$primary"
                    alignItems="center"
                    justifyContent="center"
                >
                    <FileUploadRoundedIcon size={16} color="white" />
                </View>

                <SizableText size="$2" textAlign="center">
                    <SizableText
                        size="$2"
                        color="$primary"
                        cursor="pointer"
                        hoverStyle={{ textDecorationLine: 'underline' }}
                    >
                        Click to upload
                    </SizableText>{' '}
                    or drag and drop
                    {'\n'}PDF
                </SizableText>
            </Card>
        </View>
    )
}
